import { useState, useEffect } from "react";
import EvaluationQuestion from "./EvaluationQuestion";
import { CancelIcon, FinishFlag } from "../../assets/icons/icons";
import "./Evaluation.css";

const EvaluationFrame = ({ session, handleAnswer, onCancel, onPrevious, onNext, waiting }) => { 
  const [disablePrevious, setDisablePrevious] = useState(false);
  const { currentQuestion: question, progress, numSequences } = session;
  const answer = session.answers?.[question?.id] ?? null;
  const showPrevious = false;
  const showCancel = !!onCancel;

const ProgressBar = ({ current, total }) => {
  const pct = total ? Math.round((current / total) * 100) : 0;
  return (
    <div
      className="progress-bar-container"
      title={`Progress: ${current} of ${total} (${pct}%)`}
    >
      <div className="progress-bar-icon left-icon" />
      <div className="progress-bar-track">
        <div className="progress-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="progress-bar-icon right-icon">
        <FinishFlag className="finish-flag-icon" />
      </div>
    </div>
  );
}

  useEffect(() => {
    if (showPrevious && question.index > 0) {
      setDisablePrevious(false);
    } else {
      setDisablePrevious(true);
    }
  }, [question, showPrevious]);

  return (
    <div className="evaluation-step-container">
      { numSequences > 0 &&
        <ProgressBar 
          current={progress || 0} 
          total={numSequences * 3 || 0} 
        />
      }
      <div className="evaluation-header">
        <h2>Athlete Wellness Evaluation</h2>        
        {showCancel && (
          <button className="cancel-btn-header" onClick={onCancel} title="Cancel the session; your session data will be deleted to protect your privacy.">
            <CancelIcon />
            Cancel Session
          </button>
        )}
      </div>
      
      {<p style={{ color: "blue" }}>Please take your time to reflect on the statement.</p>}
      
      <EvaluationQuestion
        className="evaluation-question-container"
        question={question}
        answer={answer}
        handleAnswer={handleAnswer}
        onNext={onNext}
        waiting={waiting}
      />
      
      {showPrevious && (
        <div className="button-row">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              marginTop: "2rem",
              width: "100%",
            }}
          >
            <button className="previous-btn" disabled={disablePrevious} onClick={onPrevious}>
              Previous
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EvaluationFrame;
